export default {
    excess: "Одговорност за вишок",
    security: "Сигурносен депозит",
    fuel_policy: "Политика на гориво",
    like_for_like: "Исто за исто",
    full_to_full: "Полн резервоар до полн резервоар",
    mileage: "Милажа: {mileage} мили по изнајмување",
    unlimited_mileage: "Неограничена милажа",
    non_refundable: "Неисплативо",
    free_cancellation_until: "Бесплатно откажување до {date}",
    cancellation_with_terms: "Откажување {0} во согласност со ",
    t_c_text: "Услови и услови",
    two_free_extras: "Два бесплатни дополнителни на земање",
    glass_tyres_covered: "Покриени стакло и гуми"
}
